import { AxiosResponse } from "axios";

import apiRequest from "../../../utils/apiUtils/apiRequest";
import SubscriptionRequestDTO from "../../../models/SubscriptionRequestDTO";
import UnsubscriptionRequestDTO from "../../../models/UnsubscriptionRequestDTO";
// import apiUrls from "../../utils/apiUtils/apiUrls";


export function ping() {
    return apiRequest.get("/status").then((response: AxiosResponse) => {
        return response;
    });
}

export function doSubscription(request: SubscriptionRequestDTO) {
    const url = "/training/emails/subscribe";
    return apiRequest.post(url, request).then((response: AxiosResponse) => {
        return response;
    });

}

export function unsubscribe(request: UnsubscriptionRequestDTO) {
    const url = "/training/emails/unsubscribe";
    return apiRequest.post(url, request).then((response: AxiosResponse) => {
        return response;
    });

}

export function getAllEvents() {
    const url = "/events/active/all";
    return apiRequest.get(url).then((response: AxiosResponse) => {
        return response;
    });

}

export function getAllEventsByTraining(type: string) {
    const url = "/events/training?name=" + type;
    return apiRequest.get(url).then((response: AxiosResponse) => {
        return response;
    });

}

